import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import {
  AccountTree as AccountTreeIcon,
  FindInPage as FindInPageIcon,
  FactCheck as FactCheckIcon,
  AutoFixHigh as AutoFixHighIcon
} from '@mui/icons-material';

const steps = [
  {
    number: '01',
    icon: <AccountTreeIcon sx={{ fontSize: 36, color: '#1976d2' }} />,
    title: 'Define',
    description: 'Build document flows: define fields, validation rules, and extraction schema with the visual flow builder and AI-assisted generation.'
  },
  {
    number: '02',
    icon: <FindInPageIcon sx={{ fontSize: 36, color: '#1976d2' }} />,
    title: 'Extract',
    description: 'Submit PDFs or images. Get precise field extractions with bounding box visualization and per-field scroll animations.'
  },
  {
    number: '03',
    icon: <FactCheckIcon sx={{ fontSize: 36, color: '#1976d2' }} />,
    title: 'Verify',
    description: 'Upload ground-truth evaluation documents, run QA policies, and review per-field validation results and accuracy metrics.'
  },
  {
    number: '04',
    icon: <AutoFixHighIcon sx={{ fontSize: 36, color: '#1976d2' }} />,
    title: 'Improve',
    description: 'Fine-tune models from evaluation datasets and use AI agents to continuously improve extraction accuracy over time.'
  }
];

const HowItWorksSection = () => (
  <Box
    id="how-it-works"
    sx={{
      py: 8,
      background: 'linear-gradient(135deg, #e3f2fd 0%, #d0e8fa 100%)',
      position: 'relative',
      zIndex: 1,
      borderTop: '1px solid rgba(25,118,210,0.12)',
      borderBottom: '1px solid rgba(25,118,210,0.12)'
    }}
  >
    <Container maxWidth="lg">
      <Typography variant="h3" align="center" sx={{ fontWeight: 700, mb: 2, color: '#1976d2' }}>
        How It Works
      </Typography>
      <Typography variant="body1" align="center" sx={{ color: '#555', mb: 6, maxWidth: 600, mx: 'auto' }}>
        A complete pipeline from extraction definition to continuous model improvement.
      </Typography>
      <Grid container spacing={4}>
        {steps.map((step) => (
          <Grid item xs={12} sm={6} md={3} key={step.number}>
            <Box
              sx={{
                height: '100%',
                p: 3,
                borderRadius: 3,
                background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                border: '1px solid rgba(25, 118, 210, 0.15)',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: '0 16px 40px rgba(25, 118, 210, 0.2)',
                  border: '1px solid rgba(25, 118, 210, 0.3)'
                }
              }}
            >
              <Typography variant="h2" sx={{ fontWeight: 800, color: 'rgba(25, 118, 210, 0.12)', lineHeight: 1, mb: 1 }}>
                {step.number}
              </Typography>
              <Box sx={{ mb: 1.5 }}>{step.icon}</Box>
              <Typography variant="h6" sx={{ fontWeight: 700, mb: 1.5, color: '#000' }}>
                {step.title}
              </Typography>
              <Typography variant="body2" sx={{ color: '#333', lineHeight: 1.6 }}>
                {step.description}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Container>
  </Box>
);

export default HowItWorksSection;
